module.exports = __webpack_public_path__ + "img/blue-red-ghost.2b381b40.webp";